
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/specials/offer/[specialId]",
      function () {
        return require("private-next-pages/stores/[cName]/specials/offer/[specialId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/specials/offer/[specialId]"])
      });
    }
  